export const environment = {
  production: false,
  apiBaseUrl: 'https://tndapi.vneduai.com/dev/',
  apiAuthUrl: 'https://tndapi.vneduai.com/dev/auth/auth',
  apiAdminUrl: 'https://tndapi.vneduai.com/dev/auth/admin',
  apiOrganizationsUrl: 'https://tndapi.vneduai.com/dev/auth',
  apiAddressUrl: 'https://tndapi.vneduai.com/dev/c-address/api/addresses',
  apiImageUrl: 'https://d13dxp8d6go1v2.cloudfront.net',
  apiAuthPath: 'g-auth/v3',
  apiDataCollectionPath: 'g-data-collection/v1',
  apiThamDinhPath: 'g-evaluation/api/v1',
  apiThamDinhBdsPath: 'g-evaluation/api/bat-dong-san/v2',
  apiQuanLyTinDungPath: 'g-evaluation/api',
  apiOcrUrl: 'https://tndapi.vneduai.com/dev/ocr/extract',
  // apiOcrUrl: 'http://localhost:9000/assets/mock-api/ocr/extract',
  apiEvaluationUrl: 'https://tndapi.vneduai.com/dev/g-evaluation/api',
  useMockSheetData: false // Sử dụng file JSON local thay vì gọi API
};
